export default "__VITE_ASSET__9051d8fe__"